module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/arrow-banner.b0a42038.svg";